import axiosInstance from "../../api/axios";
export default {
  namespaced: true,
  state: {
    category: null,
    newCategory: null,
  },
  mutations: {
    setCategory(state, payload) {
      state.category = payload;
    },
    setNewCategory(state, payload) {
      state.newCategory = payload;
    },
  },
  actions: {
    async getCategories({ commit }) {
      try {
        const { data } = await axiosInstance.get(`${process.env.VUE_APP_API_IP}newsCategories`);
        if (!data.success) {
          commit("setCategory", []);
          return;
        }
        commit("setCategory", data.category);
        return data.category;
      } catch (error) {
        console.log(error);
        commit("setCategory", []);
      }
    },
    async createNewCategory({ commit }, newCategory) {
      try {
        const { data } = await axiosInstance.post(`${process.env.VUE_APP_API_IP}newsCategories`, { newCategory });
        commit("setNewCategory", data);
      } catch (error) {
        console.log(error);
      }
    },
  },
};
